var _excluded = ["heading", "content", "cta"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import styled from "styled-components";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var additionalSafeSpace = 20; /* Additional space for box-shadow and hover state of items so that they're not hidden through overflow: hidden */

var Container = styled.div.withConfig({
  componentId: "sc-vxmec-0"
})(["display:grid;grid-gap:", ";", "{grid-template-columns:1fr auto;}"], space(4), breakpoint("large"));
var Content = styled.div.withConfig({
  componentId: "sc-vxmec-1"
})(["", "{grid-column:1/-1;order:1;margin:", " 0;padding:", " 0;}"], breakpoint("large"), space(-1 * additionalSafeSpace), space(additionalSafeSpace));

/**
 * 1. Style needed so it makes cta clickable because otherwise it's covered by slider's additional safe space
 * */
var Cta = styled.div.withConfig({
  componentId: "sc-vxmec-2"
})(["position:relative;z-index:2;justify-self:center;", "{align-self:flex-end;justify-self:flex-end;}"], breakpoint("large"));
function ProductCardsWithHeaderOrg(_ref) {
  var heading = _ref.heading,
    content = _ref.content,
    cta = _ref.cta,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(Container, restProps, /*#__PURE__*/React.createElement("div", null, heading), /*#__PURE__*/React.createElement(Content, null, content), /*#__PURE__*/React.createElement(Cta, null, cta));
}
export default ProductCardsWithHeaderOrg;